module.exports = __webpack_public_path__ + "img/ja-possui-o-produto.a48b7ee4.png";